import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Link from 'app/common/components/link';
import { components } from '@glowforge/ui-common';

import ReferralMain from './main';

const { Button, Markdown } = components;

const ReferralStripe = props => (
  <div className='ReferralPaymentPage contentPage'>
    <ReferralMain {...props} />
    <Button
      onClick={props.navigateToStripe}
      type='default'
      size='large'>
      {props.pageStrings['credit-removal-button-rto']}
    </Button>
    <div className='content footer-info'>
      <Markdown className='paragraph' source={_.get(props.paypalLinkText, 'text')} />
      <Link to={`/referral-payment?state=${props.path}&paypal=true`} className='button text'>
        {_.get(props.paypalLinkText, 'title')}
      </Link>
    </div>
  </div>
);

ReferralStripe.propTypes = {
  navigateToStripe: PropTypes.func.isRequired,
  pageStrings: PropTypes.objectOf(PropTypes.string).isRequired,
  paypalLinkText: PropTypes.objectOf(PropTypes.string).isRequired,
  path: PropTypes.string.isRequired,
};

export default ReferralStripe;



// WEBPACK FOOTER //
// ./app/components/support/referral/stripe-first.jsx